module.exports = __webpack_public_path__ + "static/img/iPhone_screen3.5e61a75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iPhone_screen3.png
// module id = Z6mL
// module chunks = 0